<template lang="jade">
router-view
</template>
<script>
export default {
}
</script>
<style lang="stylus">
</style>
